const ICONS = {

};

function inventoryIconStore() {
    return function(itemName) {
        let itemCategories = itemName.split('.');

        const majorCategory = itemCategories[0],
            secondaryCategory = itemCategories[1],
            tertiaryCategory = itemCategories[2],
            lastCategory = _.last(itemCategories);

        const vehicleCategory = 'vehicle',
            cyclesCategory = 'cycles',
            bikesCategory = 'bikes',
            carsCategory = 'cars';

        const furnitureCategory = 'furniture';

        const materialCategories = [
            'cane', 'fabric', 'glasstop', 'leather', 'metaltop',
            'withglassfitments', 'withoutglassfitments',
            'wooden', 'woodentop'
        ];

        /**
         * For cars and bikes,
         *  since we do not have individual model icons,
         *  re use the icon for the make of the vehicle.
         */
        if (majorCategory === vehicleCategory && itemCategories.length > 3) {
            return {
                hasDuplicatedIcon: true,
                icon: tertiaryCategory
            };
        }

        if (majorCategory === vehicleCategory && secondaryCategory === cyclesCategory) {
            return {
                hasDuplicatedIcon: true,
                icon: secondaryCategory
            };
        }

        if (majorCategory === furnitureCategory && _.contains(materialCategories, lastCategory.toLowerCase())) {
            return {
                hasCustomIcon: true,
                icon: ['/images/icon/', lastCategory, '.svg'].join('')
            };
        }

        return {};
    }
}

export default inventoryIconStore;


// WEBPACK FOOTER //
// ./client/app/common/inventory/inventory.icons.js